<template>
    <el-form ref="form" :model="form" :rules="rules" label-width="120px" v-if="form.fRoleID">
       
        <el-form-item label="职称名称" prop="fName">
            <el-input v-model="form.fName"></el-input>
        </el-form-item>
        <el-form-item label="创建人" prop="fCreater">
            <el-input v-model="form.fCreater" readonly></el-input>
        </el-form-item>
        <el-form-item label="创建时间" prop="fCreateTime">
            <el-input v-model="form.fCreateTime" readonly></el-input>
        </el-form-item>
        <el-form-item label="最后修改人" prop="fModify">
            <el-input v-model="form.fModify" readonly></el-input>
        </el-form-item>
        <el-form-item label="最后修改时间" prop="fModifyTime">
            <el-input v-model="form.fModifyTime" readonly></el-input>
        </el-form-item>
   
    </el-form>
      <el-form ref="form" :model="form" :rules="rules" label-width="120px" v-else>
        <el-form-item label="职称名称" prop="fName">
            <el-input v-model="form.fName"></el-input>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
  data: function(){
    return {
      rules: {
        fName: [{ required: true, message: "必填项", trigger: "change" }],
        fDes: [{ required: true, message: "必填项", trigger: "change" }],
      }
    }
  },
  props: {
    form: Object
  },
  methods: {
    submit: function(onValid, onSuccess, onFailed, onComplete) {
      this.$refs.form.validate(valid => {
        if (valid) {
          let data = Object.assign({}, this.form);
          onValid(data);
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style>

</style>